// Initialisation du slider product-banner sur mobile
class ProductBannerSlider {
  constructor() {
    this.breakpoint = 768;
    this.bannerBlock = document.querySelector('.product-banner--mobile.swiper-container');
    this.swiperInstance = null;

    if (!this.bannerBlock) {
      console.log('[ProductBannerSlider] Product banner mobile not found');
      return;
    }

    // Initialiser selon la taille d'écran
    if (window.innerWidth < this.breakpoint) {
      this.initSlider();
    }

    // Gérer le resize
    this.handleResize = this.onResize.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  onResize() {
    if (window.innerWidth < this.breakpoint && !this.swiperInstance) {
      this.initSlider();
    } else if (window.innerWidth >= this.breakpoint && this.swiperInstance) {
      this.destroySlider();
    }
  }

  initSlider() {
    if (!this.bannerBlock || this.swiperInstance) return;

    // Vérifier que MinimogLibs et Swiper sont disponibles
    if (typeof MinimogLibs === 'undefined' || !MinimogLibs.Swiper) {
      console.error('[ProductBannerSlider] MinimogLibs.Swiper not found!');
      return;
    }

    // Initialiser Swiper avec autoplay - la structure HTML est déjà en place dans le Liquid
    this.swiperInstance = new MinimogLibs.Swiper('.product-banner--mobile.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.product-banner--mobile .swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
    });

    console.log('[ProductBannerSlider] Swiper initialized');
  }

  destroySlider() {
    if (!this.swiperInstance) return;

    console.log('[ProductBannerSlider] Destroying slider');

    // Détruire l'instance Swiper
    this.swiperInstance.destroy(true, true);
    this.swiperInstance = null;
  }
}

// Initialiser au chargement de la page
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductBannerSlider();
  });
} else {
  new ProductBannerSlider();
}
